
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/challenges/[id]/agreement",
      function () {
        return require("private-next-pages/web/challenges/[id]/agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/challenges/[id]/agreement"])
      });
    }
  